'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getEarliestAvailableTime;

var _iteratorFactory = require('./iteratorFactory');

function getEarliestAvailableTime(obj, from) {
    var iterator = (0, _iteratorFactory.iter)(obj)(from);

    if (!iterator.hasNext()) {
        return null;
    }

    var status = iterator.next();

    return status.status === 'available' ? from.unix() * 1000 : status.until;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/availability/dist/utils/getEarliestAvailableTime.js
// module id = 678
// module chunks = 0